module.exports = __webpack_public_path__ + "img/frutos-cascara.987a661b.svg";